import { IntlFormatters } from "react-intl";
import { TSchoolType } from "../schemas/signup";
import defineMessages from "./defineMessages";

const displayNameMessages = defineMessages({
    username: {
        id: "account.displayNames.username",
    },
    first_name: {
        id: "account.displayNames.first_name",
    },
    full_hu: {
        id: "account.displayNames.full_hu",
    },
    full: {
        id: "account.displayNames.full",
    },
});

export const displayNames = (fm: IntlFormatters["formatMessage"]) => {
    return [
        {
            label: fm(displayNameMessages.username),
            value: "username",
        },
        {
            label: fm(displayNameMessages.first_name),
            value: "first",
        },
        {
            label: fm(displayNameMessages.full),
            value: "full",
        },
        {
            label: fm(displayNameMessages.full_hu),
            value: "full_hu",
        },
    ];
};

const genderMessages = defineMessages({
    man: {
        id: "account.gender.man",
    },
    woman: {
        id: "account.gender.woman",
    },
});

export const genders = (fm: IntlFormatters["formatMessage"]) => {
    return [
        {
            label: fm(genderMessages.man),
            value: 0,
        },
        {
            label: fm(genderMessages.woman),
            value: 1,
        },
    ];
};

const schoolTypeMessages = defineMessages({
    primaryLow: {
        id: "account.schoolType.primaryLow",
    },
    primaryUp: {
        id: "account.schoolType.primaryUp",
    },
    musicShool: {
        id: "account.schoolType.musicShool",
    },
    gymnasium: {
        id: "account.schoolType.gymnasium",
    },
    musicGymnasium: {
        id: "account.schoolType.musicGymnasium",
    },
});

export const schoolTypes = (fm: IntlFormatters["formatMessage"]): { label: string, value: TSchoolType }[] => {
    return [
        {
            label: fm(schoolTypeMessages.primaryLow),
            value: "primaryLow",
        },
        {
            label: fm(schoolTypeMessages.primaryUp),
            value: "primaryUp",
        },
        {
            label: fm(schoolTypeMessages.musicShool),
            value: "musicShool",
        },
        {
            label: fm(schoolTypeMessages.gymnasium),
            value: "gymnasium",
        },
        {
            label: fm(schoolTypeMessages.musicGymnasium),
            value: "musicGymnasium",
        },
    ];
};

const invalidEmailProviders = ["yahoo.com", "hotmail.com", "live.com", "aol.com"];

export const emailProviderValidator = (email: string) => {
    return (
        invalidEmailProviders.filter(provider => {
            return email.indexOf(provider) > -1;
        }).length === 0
    );
};

export const reg_userName = /^(?:[A-Za-z]){5}(?:[A-Za-z0-9]){3,7}$/i;

export const reg_email = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i;


const privacyMessages = defineMessages({
    justMe: {
        id: "memory.groups.privacy.justMe",
    },
    leaders: {
        id: "memory.groups.privacy.leaders",
    },
    everyone: {
        id: "memory.groups.privacy.everyone",
    },
});

export const choirPrivacies = (fm: IntlFormatters["formatMessage"]) => [
    {
        value: 0,
        label: fm(privacyMessages.justMe),
    },
    {
        value: 1,
        label: fm(privacyMessages.leaders),
    },
    {
        value: 2,
        label: fm(privacyMessages.everyone),
    },
];

export const nameMinLength = 5;
export const nameMaxLength = 30;
